export type Type = {
	origin: string;
	originLocationId: string;
	productionMethod: string;
	productionMethodId: string;
	source: string | null;
	value: number;
};

export function create(): Type {
	return {
		origin: '',
		originLocationId: '',
		productionMethod: '',
		productionMethodId: '',
		source: null,
		value: 0,
	};
}
